import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {

        /**
         * 読込中の表示をするためのフラグとタイマーId
         */
        loading: false,
        loadingTimerId: null,

        users: [],

        selectedUser: null,
    },
    actions: {
        changeSelectedUser({ commit }, user) {
            commit('changeSeletedUser', user);
        },
    },
    mutations: {
        changeSeletedUser(state, user) {
            const st = state;
            st.selectedUser = user;
        },

        /**
         * 読込中のフラグをONにする処理
         * 250ms 待ってからONにする。
         * すぐにONにすると、画面がちらちらしてしまう。
         * @param state 
         */
        setLoading(state) { 
            if (state.loadingTimerId != null) {
                return;
            }
            
            state.loadingTimerId = setTimeout(function() {
                state.loading = true;
                state.loadingTimerId = null;
            }, 250);
        },

        resetLoading(state) { 
            if (state.loadingTimerId != null) {
                clearTimeout(state.loadingTimerId);
                state.loadingTimerId = null;
            }
            state.loading = false;
        },
    },
    getters: {
        getSelectedUser(state) {
            const st = state;
            return st.selectedUser;
        },
    },
});
